import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app.routing';
import {ComponentsModule} from './components/components.module';
import {AppComponent} from './app.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {BrowserModule} from '@angular/platform-browser';
import {MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS as MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/legacy-form-field';
import {PubComponent} from './pub/pub.component';
import {TagsComponent} from './tags/tags.component';
import {FeedbackComponent} from './feed-back/feedback.component';
import {ConfigAssetLoaderService} from './shared/services/config.asset.loader.service';
import {NjoyCommonModule} from './shared/modules/njoy-common/njoy-common.module';
import {TokenInterceptorService} from './login/services/token.interceptor.service';
import {DetailPartenaireComponent} from './user-profile/gestion-partenaire/detail-partenaire/detail-partenaire.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {BlockUIModule} from 'primeng/blockui';
import {GalleriaModule} from 'primeng/galleria';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AdminLayoutModule} from './layouts/admin-layout/admin-layout.module';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {CategoryComponent} from './category/category.component';
import {DetailDashboardComponent} from './dashboard/detail-dashboard/detail-dashboard.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import { CouponManagmentComponent } from './coupon-managment/coupon-managment.component';

registerLocaleData(localeFr);

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ComponentsModule,
        RouterModule,
        AppRoutingModule,
        NjoyCommonModule.forRoot({locale_id: 'fr-FR'}),
        ProgressSpinnerModule,
        BlockUIModule,
        GalleriaModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AdminLayoutModule,
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        PubComponent,
        TagsComponent,
        FeedbackComponent,
        DetailPartenaireComponent,
        CategoryComponent,
        DetailDashboardComponent,
        ContactUsComponent,
        CouponManagmentComponent

    ],
    providers: [{provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'fill'}},
        {
            provide: APP_INITIALIZER,
            useFactory: (configService: ConfigAssetLoaderService) => () => configService.loadConfigurations(),
            deps: [ConfigAssetLoaderService],
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        },
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: LOCALE_ID, useValue: 'fr-FR'}
    ],
    bootstrap: [AppComponent],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, '../assets/locales/', '.json');
}
